import { createFileRoute } from "@tanstack/react-router";
import { EnvironmentsScreen } from "./-settings/EnvironmentsScreen";

export const Route = createFileRoute("/$workspace/$project/settings/environments")({
  staticData: { title: "Environments" },
  component: EnvironmentsScreen,
});
